module.exports = __webpack_public_path__ + "static/front_logo-499d077aad1074114cf5baae2c1b326a.jpg";